<div layout="column" layout-gt-sm="row">
  <div ui-view="text" style="min-width: 75%" flex></div>
  <neo-action-button buttons="vm.buttons" ng-if="vm.buttons.actions.length > 0"></neo-action-button>
</div>
